<template>
  <div
    class="project-item"
    :class="{'project-close': projectItemData.status*1 !== 1}"
    style="cursor: pointer;"
    @click.prevent.stop="clickHandle(projectItemData)"
  >
    <div class="project-item-tit">
      <h4>{{ projectItemData.projectname }}</h4>
      <div
        class="project-tool"
      >
        <template v-if="projectItemData.roleInfo && Object.keys(projectItemData.roleInfo).length > 0">
          <a-tag
            :color="projectItemData.roleInfo.color"
          >
            {{ projectItemData.roleInfo.rolename }}
          </a-tag>
        </template>
      </div>
    </div>
    <div class="project-item-content">
      <p>{{ projectItemData.creater }}{{ $t('message["128"]') }}{{ timestampToTime(projectItemData.addtime, '.') }}</p>
      <p class="main-role-box">
        {{ $t('message["330"]') }}：
        <em
          v-for="(item,index) in projectItemData.adminInfo"
          :key="index"
        >
          {{ item.truename }}
          <template v-if="index !== projectItemData.adminInfo.length-1">、</template>
        </em>
      </p>
    </div>
    <div class="pro-item-time-state">
      <span class="pay-type">
        <!-- 询盘项目会员 -->
        <template v-if="!isMember">
          <!-- vip = 1 基础版 -->
          <template v-if="projectItemData.vip * 1===1">
            <!-- 351:高级版 -->
            <em class="pay-type-h">{{ $t('message["351"]') }}</em><i>
              {{ lang==='en'? 'expires': '' }}
              {{ timestampToDate(projectItemData.totime, '-') }}
              {{ lang==='zh'? '到期': '' }}
            </i>
          </template>
          <template v-else>
            <template v-if="projectItemData.remark && projectItemData.remark.usedvip*1 === 1">
              <em class="pay-type-h">{{ $t('message["351"]') }}</em>
              <span class="used-vip-time">{{ $t('message["1315"]') }}</span>
            </template>
            <!-- 637：免费版 -->
            <em v-else>{{ $t('message["637"]') }}</em>
          </template>
        </template>
        <template v-else>
          <!-- 付费版本 -->
          <template v-if="projectItemData.vip * 1">
            <em class="pay-type-h">{{ getVipType(projectItemData.vip) }}</em><i>
              {{ lang==='en'? 'expires': '' }}
              {{ timestampToDate(projectItemData.totime, '-') }}
              {{ lang==='zh'? '到期': '' }}
            </i>
          </template>
          <!-- 免费版本 -->
          <em v-else>{{ $t('message["637"]') }}</em>
        </template>
      </span>
      <!-- "1575": "正常" -->
      <span
        v-if="projectItemData.status*1 === 1"
        class="pro-item-status"
      > <i />{{ $t('message["1575"]') }}</span>
      <!-- 401：关闭 -->
      <span
        v-else
        class="pro-item-status has-close"
      ><i />{{ $t('message["401"]') }}</span>
      <div
        class="project-tool-config"
        @click.prevent.stop="toolClick"
      >
        <template v-if="admin===1 || (founder === 1)">
          <manage-pro :project-item-data="projectItemData" />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { timestampToTime, timestampToDate } from '@/store/organization/scripts.js'
import ManagePro from './managePro/ManagePro'
import { mapActions, mapState, mapMutations } from 'vuex'
import { getLang, setPid, getAuth, setNewAuth } from '@/lib/storage'
export default {
  components: {
    ManagePro
  },
  props: {
    projectItemData: {
      type: Object,
      default () {
        return {}
      }
    },
    admin: {
      type: Number,
      default: 0
    },
    founder: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState('organization/org', ['projectType']),
    isadmin () {
      return this.admin
    },
    roleid () {
      return this.$store.state.roleid
    },
    isVip () {
      return this.$store.state.baseinfo.vip === 1
    },
    isfounder () {
      return this.$store.state.baseinfo.isfounder
    },
    lang () {
      return this.getLang()
    },
    isMember () {
      return this.projectType === 'member'
    }
  },
  methods: {
    timestampToTime,
    timestampToDate,
    getLang,
    setPid,
    getAuth,
    setNewAuth,
    ...mapActions(['permissionMenu']),
    ...mapActions('organization/org', ['projectToLink']),
    ...mapMutations(['setRoleDefault']),
    async clickHandle (data) {
      if (data.status * 1 === 1) {
        const { cid, projectid } = data
        const chain = await this.projectToLink()
        chain
          .params({ cid, projectid, pType: this.projectType === 'member' ? 2 : 1 })
          .onSuccess(async (raw) => {
            const { Project: tid } = raw
            let to = ''
            let linkName = ''
            let routerName = 'InqueryList'
            switch (raw.type) {
              case 1: // 负责人, 观察员
                linkName = { type: 'inquiry-manager-all', from: 'all' }
                break
              case 2: // 开发
                linkName = { type: 'inquiry-dev', from: 'my' }
                break
              case 3: // 接待
                linkName = { type: 'inquiry-add', from: 'my' }
                break
              default: // 销售
                linkName = { type: 'inquiry-followup', from: 'my' }
            }
            const pid = raw.Project // this.$store.state.pid
            // console.log(pid)
            //   console.log(this.getLang())
            //   this.setNewAuth(this.getAuth())
            if (this.isMember) {
              const $location = window.location
              // const $query = '?auth=' + this.getAuth() + '&pid=' + projectid
              if (process.env.NODE_ENV === 'development') {
                location.href = '//' + $location.hostname + ':94/mc/project/' + pid + '/overview'
              } else {
                location.href = '//' + $location.host + '/mc/project/' + pid + '/overview'
              }
            } else {
              this.setPid(tid)
              this.$store.commit('setPid', tid)
              if (raw.type === 0) {
                this.setRoleDefault(true)
                const chain = await this.permissionMenu() // 先请求菜单数据，判断自定义角色默认展示页
                chain.onSuccess(res => {
                  for (let key in res) {
                    if (key === 'inquiry-mine' && res[key]['state']) {
                      let item = res[key]
                      if ('child' in item) {
                        for (let cKey in item['child']) {
                          linkName = { type: cKey, from: 'my' }
                          break
                        }
                      }
                      break
                    }
                    if (key === 'inquiry-mine' && !res[key]['state']) {
                    // console.log('查重： inquiry-check-repeat')
                      routerName = 'InqueryRepeat'
                      linkName = {}
                      break
                    }
                  }
                }).onComplete(() => {
                // console.log(linkName)
                  to = {
                    name: routerName,
                    params: {
                      pid
                    },
                    query: linkName
                  }
                  this.$router.push(to)
                })
              } else {
                to = {
                  name: routerName,
                  params: {
                    pid
                  },
                  query: linkName
                }
                this.$router.push(to)
              }
            }
          })
          .fetch()
      } else {
        this.$warning({
          content: this.$t('message["1327"]') + '！'
        })
      }
    },
    toolClick () {
      return false
    },
    // 会员项目获取版本
    getVipType (type) {
      let str = '免费版'
      switch (type * 1) {
        case 0: {
          str = '免费版'
          break
        }
        case 1: {
          str = '基础版'
          break
        }
        case 2: {
          str = '标准版'
          break
        }
        case 3: {
          str = '高级版'
          break
        }
        default: {
          str = '免费'
        }
      }
      return str
    }
  }
}
</script>
<style lang="scss" scoped>
.project-item::v-deep {
  width: 330px;
  height: 171px;
  box-shadow: 0 2px 4px 0 #eceff1;
  border: solid 1px #eceff1;
  background-color: #fff;
  border-radius: 4px;
  float: left;
  padding: 25px 24px 2px;
  box-sizing: content-box;
  margin:0 24px 24px 3px;
  margin-bottom: 24px;

  .project-item-tit {
    position: relative;
    margin-bottom: 42px;

    h4 {
      font-size: 14px;
      font-weight: bold;
    }

    .project-tool {
      position: absolute;
      right: 0;
      top: 0;
      .ant-tag {
        margin-right: 0
      }
    }
  }

  .project-tool-config {
    position: absolute;
    right: 0;
    bottom: 0;
  }

  .project-item-content {
    font-size: 12px;
    color: #808080;
    position: relative;
    z-index: 3;
    em {
      font-style: normal;
    }

    p {
      line-height: 16px;
      margin-bottom: 8px;
      color: #b3b3b3;
    }
    .main-role-box {
      width: 278px;
      height: 16px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .pro-item-time-state {
    padding-top: 8px;
    position: relative;
    font-size: 12px;
    z-index: 4;

    .pro-item-status {
      // position: absolute;
      height: 20px;
      line-height: 20px;
      border-radius: 4px;
      padding: 0 4px;
      border: 1px solid #eceff1;
      color: #42c27e;
      // right: 0;
      vertical-align: middle;
      // left: 8px;
      margin: 0 8px;
      // bottom: 0;
      font-size: 12px;
       i{
         display: inline-block;
         width: 4px;
         height: 4px;
         border-radius: 50%;
         background:#42c27e;
         vertical-align: middle;
         margin-right: 4px;
         margin-bottom: 4px;
       }
    }

    .has-close {
      color: #333;
      i {
        background: #e0e0e0;
      }
    }

    .pay-type {
      em {
        color: #898989;
        font-style: normal
      }
      i{
        font-style: normal;
        color: #666;
        margin: 0 0 0 8px;
      }

      .pay-type-h {
        color: #5077aa;
      }
      .used-vip-time {
        color:#F57676;
        margin-left: 6px;
      }
    }
  }
}

.project-item:hover {
  box-shadow: 0 8px 8px 0 #eceff1;
}

.mr-0 {
  margin-right: 0;
}
.project-close {
  opacity: 0.5;
}
.project-close:hover {
  opacity: 1;
}
</style>
